// src/components/layout/Layout.tsx
import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import type { User } from '../../types/auth';

interface LayoutProps {
  user: User | null;
  isAuthenticated: boolean;
  remainingCalls: number;
  onShowHistory: () => void;
  onShowLogin: () => void;
  onSignOut: () => void;
  onShowContact: () => void;
  onShowPrivacy: () => void;
  onShowTerms: () => void;
  onShowAbout: () => void;
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
  user,
  isAuthenticated,
  remainingCalls,
  onShowHistory,
  onShowLogin,
  onSignOut,
  onShowContact,
  onShowPrivacy,
  onShowTerms,
  onShowAbout,
  children
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header
        user={user}
        isAuthenticated={isAuthenticated}
        remainingCalls={remainingCalls}
        onShowHistory={onShowHistory}
        onShowLogin={onShowLogin}
        onSignOut={onSignOut}
      />
      <main className="flex-1 flex justify-center items-start pt-4 lg:pt-8 pb-4 lg:pb-8">
        <div className="w-full max-w-6xl mx-auto px-4 lg:px-8">
          {children}
        </div>
      </main>
      <Footer 
        onShowContact={onShowContact}
        onShowPrivacy={onShowPrivacy}
        onShowTerms={onShowTerms}
        onShowAbout={onShowAbout}
      />
    </div>
  );
};